// MyLifeStages.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import Tooltip from '../../components/utils/Tooltip';

const MyLifeStages = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const navigate = useNavigate();
  const userId = authState.user._id;
  const [createdLifeStages, setCreatedLifeStages] = useState([]);
  const [hasCretaedLifeStageStatus, setHasCretaedLifeStageStatus] = useState(false);
  const [hasCretaedLifeStageStatusMsg, setHasCretaedLifeStageStatusMsg] = useState('');
  const [selectedLifeStageId, setSelectedLifeStageId] = useState([]);
  const [selectedViewMemberLifeStageId, setSelectedViewMemberLifeStageId] = useState(false);
  const [selectedAddMemberLifeStageId, setSelectedAddMemberLifeStageId] = useState(false);

  const [hasNewMemberCodeClicked, setHasNewMemberCodeClicked] = useState(false);
  // const [newMemberCode, setNewMemberCode] = useState('');

  const [newMemberCodeStatus, setNewMemberCodeStatus] = useState(false);
  const [newMemberCodeStatusMsg, setNewMemberCodeStatusMsg] = useState('');
  const [newMemberCode, setNewMemberCode] = useState('');
  const [newMemberId, setNewMemberId] = useState('');
  const [newMemberName, setNewMemberName] = useState('');
  const [newMemberEmail, setNewMemberEmail] = useState('');
  const [newMemberCodeMsg, setNewMemberCodeMsg] = useState('');
  const [verifyNewMemberCodeButtonClicked, setVerifyNewMemberCodeButtonClicked] = useState(false);
  const [error, setError] = useState('');
  const [addNewButtonClickedStatus, setAddNewButtonClickedStatus] = useState(false);
  const [addNewMemberRecordStatus, setAddNewMemberRecordStatus] = useState(false);
  const [addNewMemberRecordStatusMsg, setAddNewMemberRecordStatusMsg] = useState('');

  useEffect(() => {
    fetchMyLifeStageList(); 
  }, []);

   const fetchMyLifeStageList = useCallback(() => {
    // console.log("fetchMyLifeStageList for API call ", userId);
    const config = {
        url: "/mylifestages/mycreatedlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { createdBy: userId }
    };
  
    fetchData(config)
        .then(response => {
          // console.log("API Response: ", response); 
            if (response && response.status) {
                // console.log("lifestage list found ", response);
                setHasCretaedLifeStageStatus(true);
                setCreatedLifeStages(response.lifestages);
                setHasCretaedLifeStageStatusMsg("LifeStages found. 😊");
            } else {
                // console.log("LifeStages Code Not found");
                setHasCretaedLifeStageStatusMsg(`LifeStages not found! 😔`);
            }
        })
        .catch(error => {
            // console.log("LifeStages Not found!", error);
            setHasCretaedLifeStageStatusMsg("Error in getting data");
        });
  }, [fetchData, authState.token]);
  
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
  }, [authState.isLoggedIn, fetchMyLifeStageList]);

  const handleCreateLifeStageClick = () => {
    navigate("/myprofile-createlifestage");
  };

  const handleLifeStageView = (_id) => {
    setSelectedLifeStageId(prevId => (prevId === _id ? null : _id));
  };

  const handleAddMembers = (_id) => {
    setSelectedAddMemberLifeStageId(prevId => (prevId === _id ? null : _id));
  };

  const handleViewMembers = (_id) => {
    setSelectedViewMemberLifeStageId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const lifestageTypeNames = {
    FAC: "Factory",
    MAC: "Machine",
    BRA: "Branch",
    BUI: "Building",
    SCH: "School",
    COL: "College",
    UNI: "University",
    OFF: "Office",
    SHO: "Shop",
    LOC: "LifeStage",
    IND: "Indoor",
    OUT: "Outdoor",
    OTH: "Others",
  };


  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - My Think5Whys LifeStages</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className="flex justify-between mt-4 items-center border-b border-b-gray-300">
          <h3 className='text-lg mt-1 mx-2 text-white'>LifeStages I Created</h3>
          <button
            className='bg-purple-700'
            onClick={() => handleCreateLifeStageClick()}
            style={{ maxWidth: '150px' }}
          >
            Create New
          </button>
        </div>
        <div className="mt-4">
          {createdLifeStages.length === 0 ? (
            <div className='flex justify-center'>
              <p className='text-yellow-600 text-2xl mt-20 h-80'>You Have Not Created A LifeStage Yet</p>
            </div>
          ) : (
            createdLifeStages.map((lifestage, index) => (
              <div key={lifestage._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium text-black'>
                    {index + 1}. {lifestage.lifestageTitle}
                  </span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleLifeStageView(lifestage._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                </div>
                {selectedLifeStageId === lifestage._id && (
                  <div className='bg-gray-200 text-black'>
                    <p><strong>Created Date:</strong> {formatDateTime(lifestage.dateCreated)}</p>
                    <p><strong>My LifeStage Remarks:</strong> {lifestage.myLifeStageRemarks}</p>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </MainLayout>
  );  
};

export default MyLifeStages;


